import {Vote} from '@domain/rcfa'
import {ApiClient} from '@hconnect/apiclient'
import {useMutation, useQueryClient} from '@tanstack/react-query'

type VoteUpdateData = {
  vote: Vote
}

export function useCreateVote(analysisId: string | undefined, nodeId: number) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (voteData: VoteUpdateData) => {
      const path = `/rootcausefailureanalysis/analyses/${analysisId}/tree/nodes/${nodeId}/votes`

      return (await ApiClient.axiosInstance.post<void>(path, voteData)).data
    },

    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: ['node-detail']})
      await queryClient.invalidateQueries({queryKey: ['graph-data']})
      await queryClient.invalidateQueries({queryKey: ['analysis-detail']})
      queryClient.removeQueries({queryKey: ['analysis-pdfsummary']})
    }
  })
}
